import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: "Arissa's approach to medical management has significantly reduced our claim duration. Their team's responsiveness and clinical expertise are unmatched in the industry.",
  role: 'Claims Director',
  company: 'National Carrier'
}, {
  quote: "The introduction of their A+ Ancillary Services streamlined our entire workflow. We've seen a measurable drop in medical spend while ensuring injured workers get care faster.",
  role: 'VP of Risk Management',
  company: 'Regional TPA'
}, {
  quote: "Transparent reporting and true partnership. Arissa doesn't just process claims; they actively strategize with us to improve our overall program outcomes.",
  role: "Workers' Comp Manager",
  company: 'Public Entity'
}];
export function Testimonials() {
  return <section className="py-24 bg-brand-navy text-white relative overflow-hidden" data-id="element-330">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-331">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-332"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-333">
        <div className="text-center mb-16" data-id="element-334">
          <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-335">
            Client Success
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-336">
            Trusted by industry leaders
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-337">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl relative" data-id="element-338">
              <Quote className="w-10 h-10 text-brand-gold/40 absolute top-6 right-6" data-id="element-339" />
              <p className="text-white/90 text-lg leading-relaxed mb-8 relative z-10 font-light italic" data-id="element-340">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-white/10 pt-6" data-id="element-341">
                <div className="font-semibold text-brand-gold" data-id="element-342">
                  {testimonial.role}
                </div>
                <div className="text-sm text-white/60" data-id="element-343">
                  {testimonial.company}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}